import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Link } from "react-router-dom";
import Lenis from "lenis";
import { MotionConfig } from "framer-motion";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "@/components/ui/sonner";
import Nav from "@/components/Nav";
import Footer from "@/components/Footer";
import WhatsAppFloat from "@/components/WhatsAppFloat";
import Home from "@/pages/Home";
import Sobre from "@/pages/Sobre";
import Psicoterapia from "@/pages/Psicoterapia";
import Neuropsicologia from "@/pages/Neuropsicologia";
import Conteudos from "@/pages/Conteudos";
import Artigo from "@/pages/Artigo";
import PorOndeComecar from "@/pages/PorOndeComecar";
import Contato from "@/pages/Contato";
import Privacidade from "@/pages/Privacidade";
import Atendimento from "@/pages/Atendimento";
import Agendar from "@/pages/Agendar";
import Confirmacao from "@/pages/Confirmacao";
import Admin from "@/pages/Admin";
import Pacote from "@/pages/Pacote";
import { ArrowButton } from "@/components/ArrowButton";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);
  return null;
};

const NotFound = () => (
  <section className="container-x flex min-h-[70vh] flex-col items-start justify-center pt-28" data-testid="not-found-page">
    <p className="eyebrow">404</p>
    <h1 className="mt-4 font-serif text-4xl font-light text-ink sm:text-5xl">Página não encontrada</h1>
    <div className="mt-8">
      <ArrowButton to="/" testId="not-found-home-button">Voltar ao início</ArrowButton>
    </div>
  </section>
);

function App() {
  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return undefined;
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  return (
    <HelmetProvider>
      <MotionConfig reducedMotion="user">
        <BrowserRouter>
          <ScrollToTop />
          <div className="min-h-screen bg-paper font-sans text-ink antialiased">
            <Nav />
            <main>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/sobre" element={<Sobre />} />
                <Route path="/psicoterapia" element={<Psicoterapia />} />
                <Route path="/neuropsicologia" element={<Neuropsicologia />} />
                <Route path="/conteudos" element={<Conteudos />} />
                <Route path="/conteudos/:slug" element={<Artigo />} />
                <Route path="/por-onde-comecar" element={<PorOndeComecar />} />
                <Route path="/contato" element={<Contato />} />
                <Route path="/privacidade" element={<Privacidade />} />
                <Route path="/atendimento/:slug" element={<Atendimento />} />
                <Route path="/agendar" element={<Agendar />} />
                <Route path="/agendar/:slug" element={<Agendar />} />
                <Route path="/confirmacao/:protocol" element={<Confirmacao />} />
                <Route path="/admin" element={<Admin />} />
                <Route path="/pacote" element={<Pacote />} />
                <Route path="*" element={<NotFound />} />
              </Routes>
            </main>
            <Footer />
            <WhatsAppFloat />
            <Toaster position="bottom-center" data-testid="toast-container" />
          </div>
        </BrowserRouter>
      </MotionConfig>
    </HelmetProvider>
  );
}

export default App;
